import { render, staticRenderFns } from "./WrDashboard.vue?vue&type=template&id=04321c92&"
import script from "./WrDashboard.vue?vue&type=script&lang=js&"
export * from "./WrDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports